import { cn } from "@/lib/utils";
import React, { PropsWithChildren } from "react";

export function InputWrapper({
  children,
  label,
  name,
  error,
  className,
}: PropsWithChildren<{
  label: string;
  name?: string;
  error?: { message?: string } | undefined;
  className?: string;
}>) {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <label htmlFor={name} className="text-sm font-medium text-foreground">
        {label}
      </label>
      {children}
      {error && (
        <small className="text-xs font-medium text-red-700">
          {error.message}
        </small>
      )}
    </div>
  );
}
